var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Injectable, Optional, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { defaultTheme } from './default-theme';
import { AlyleServiceConfig } from './alyle-config-service';
import { gradStop } from './gradstop';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DomSanitizer } from '@angular/platform-browser';
var classId = 0;
var themeId = 1111;
var ThemeColor = /** @class */ (function () {
    function ThemeColor() {
    }
    return ThemeColor;
}());
export { ThemeColor };
/**
 * DEPRECATED
 */
export function themeProperty(color) {
    return color === 'primary' || color === 'accent' || color === 'other';
}
var LyTheme = /** @class */ (function () {
    function LyTheme(config, document, sanitizer, rendererFactory) {
        this.document = document;
        this.sanitizer = sanitizer;
        this.rendererFactory = rendererFactory;
        this._styleMap = new Map();
        /**
           * OBSOLETO
           */
        this.colors = [
            {
                name: 'pink',
                color: { '500': '#ff4b73' },
                contrast: 'light'
            },
            {
                name: 'pinkLight',
                color: { '500': '#f50057' },
                contrast: 'light'
            },
            {
                name: 'cyan',
                color: { '500': '#00bcd4' },
                contrast: 'light'
            },
            {
                name: 'red',
                color: { '500': '#FF5252' },
                contrast: 'light'
            },
            {
                name: 'amber',
                color: { '500': '#ffc107' },
                contrast: 'dark'
            },
            {
                name: 'teal',
                color: { '500': '#009688' },
                contrast: 'light'
            },
            {
                name: 'purple',
                color: { '500': '#ce30c9' },
                contrast: 'light'
            },
            {
                name: 'lightBlue',
                color: { '500': '#03A9F4' },
                contrast: 'light'
            },
            {
                name: 'blue',
                color: { '500': '#2196F3' },
                contrast: 'light'
            },
            {
                name: 'deepOrange',
                color: { '500': '#FF5722' },
                contrast: 'light'
            },
        ];
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.Id = "\u0138-" + themeId.toString(36);
        config = mergeDeep(defaultTheme, config);
        var primary = this._setColorPalette(config.primary, config.palette);
        var accent = this._setColorPalette(config.accent, config.palette);
        var other = this._setColorPalette(config.other, config.palette);
        var shade = config.shade;
        var scheme = config.schemes[config.colorScheme];
        var typography = config.typography;
        var variables = config.variables;
        // if (config.palette) {
        //   if (config.palette[config.primary]) {
        //     primary = config.palette[config.primary];
        //   }
        //   if (config.palette[config.accent]) {
        //     accent = config.palette[config.accent];
        //   }
        //   if (config.palette[config.other]) {
        //     other = config.palette[config.other];
        //   }
        // }
        var getAllColors = __assign({ primary: primary,
            accent: accent,
            other: other }, variables
        // colorText: {color: scheme.text.default},
        // bgText: {color: scheme.background.default}
        );
        getAllColors = mergeDeep(getAllColors, scheme);
        // this.createShades(primary.color[shade]);
        /* tslint:disable */
        this.AlyleUI = {
            currentTheme: config,
            palette: parsePalette(getAllColors),
        };
        /* tslint:enable */
        this.primary = new BehaviorSubject(primary);
        this.accent = new BehaviorSubject(accent);
        this.other = new BehaviorSubject(other);
        this.scheme = new BehaviorSubject(scheme);
        this.typography = new BehaviorSubject(typography);
        this.shade = new BehaviorSubject(shade);
        this.palette = new BehaviorSubject(getAllColors);
        themeId++;
    }
    LyTheme.prototype.findColor = function (data) {
        var colors = this.colors.find(function (_) { return _.name === data; });
        if (colors) {
            return colors;
        }
        else {
            return new ThemeColor();
        }
    };
    LyTheme.prototype.sanitizerStyle = function (val) {
        return this.sanitizer.bypassSecurityTrustStyle(val);
    };
    LyTheme.prototype._setColorPalette = function (key, palette) {
        var colors = palette[key];
        if (colors) {
            if (Object.keys(colors).length <= 3) {
                /**get color of first item  */
                var shades = this.createShades(colors[(Object.keys(colors)[0])]);
                colors = mergeDeep(colors, shades);
            }
            return colors;
        }
        else {
            throw new Error(key + " not found in palette");
        }
    };
    /** get class name of color */
    /** get class name of color */
    LyTheme.prototype.getClassKey = /** get class name of color */
    function (color, of) {
        return this.Id + "-" + color.replace(':', '__') + "-" + of;
    };
    // private addShades(primary, accent, other) {
    //   this.createShades(primary.color[shade]);
    // }
    // private addShades(primary, accent, other) {
    //   this.createShades(primary.color[shade]);
    // }
    LyTheme.prototype._gradStop = 
    // private addShades(primary, accent, other) {
    //   this.createShades(primary.color[shade]);
    // }
    function (colors, stops) {
        return gradStop({
            stops: stops,
            inputFormat: 'hex',
            colorArray: colors
        });
    };
    LyTheme.prototype._getGrad = function (color) {
        var toBlack = this._gradStop(['#ffffff', color], 11);
        var toWhite = this._gradStop([color, '#000000'], 33);
        toBlack.pop();
        return toBlack.concat(toWhite);
    };
    LyTheme.prototype.createShades = function (color) {
        var ar = this._getGrad(color);
        var shades = {};
        ar.forEach(function (a, b) {
            var shadeId = "" + b * 100 / 2;
            if (b <= 20) {
                shades[shadeId] = a;
            }
        });
        return shades;
    };
    LyTheme.prototype.setTheme = function (config) {
        var currentTheme = this.AlyleUI.currentTheme;
        config = mergeDeep(currentTheme, config);
        if (config) {
            var primary = this._setColorPalette(config.primary, config.palette);
            var accent = this._setColorPalette(config.accent, config.palette);
            var other = this._setColorPalette(config.other, config.palette);
            var shade = config.shade;
            var scheme = config.schemes[config.colorScheme];
            var typography = config.typography;
            var variables = config.variables;
            var getAllColors = __assign({ primary: primary,
                accent: accent,
                other: other }, variables);
            getAllColors = mergeDeep(getAllColors, scheme);
            // this.createShades(primary.color[shade]);
            /* tslint:disable */
            this.AlyleUI = {
                currentTheme: config,
                palette: parsePalette(getAllColors)
            };
            /* tslint:enable */
            this.primary.next(primary);
            this.accent.next(accent);
            this.other.next(other);
            this.scheme.next(scheme);
            this.typography.next(typography);
            this.shade.next(shade);
            this.palette.next(getAllColors);
            this.updateOthersStyles();
        }
    };
    LyTheme.prototype.color = function (color, colors, shade) {
        console.warn('DEPRECATED');
        var $shade = shade ? shade : this.AlyleUI.currentTheme.shade;
        var result;
        result = this.getColorv2(color, colors, $shade);
        return result;
    };
    /**
     * get color of `string` in palette
     * @param value
     */
    /**
       * get color of `string` in palette
       * @param value
       */
    LyTheme.prototype.colorOf = /**
       * get color of `string` in palette
       * @param value
       */
    function (value) {
        var theme = this.AlyleUI.palette;
        // const shade = this.AlyleUI.currentTheme.shade;
        var current = theme;
        var values = value.split(/:/g);
        values.forEach(function (item, index) {
            if (current[item]) {
                current = current[item];
            }
            else if (index > 0) {
                console.warn("\n\n>>>`" + value + "` undefined in LyTheme\n");
            }
        });
        if (!current['default']) {
            current = value;
        }
        else {
            current = current['default'];
        }
        return current;
    };
    LyTheme.prototype.getColorv2 = function (colorName, colors, shade) {
        var ar = colors ? colors : this.AlyleUI.palette;
        if (ar[colorName]) {
            if (typeof ar[colorName].color === 'string' || typeof ar[colorName] === 'string') {
                return ar[colorName].color || ar[colorName];
            }
            else {
                return ar[colorName].color[shade];
            }
        }
        else {
            return colorName;
        }
    };
    LyTheme.prototype.paletteOf = function (colorName) {
        return this.findColor(colorName);
    };
    LyTheme.prototype.createStyle = function (_id, fn) {
        var arg = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            arg[_i - 2] = arguments[_i];
        }
        var styleData;
        var key = createKeyOf("" + this.Id + _id);
        // console.log('existStyle', this.existStyle(key));
        if (!this._styleMap.has(key)) {
            this._styleMap.set(key, null);
            classId++;
            var id = "ly_" + classId.toString(36);
            var styleContainer = this.renderer.createElement('style');
            var styleContent = this.renderer.createText("." + id + "{" + fn.apply(void 0, arg) + "}");
            this.renderer.setAttribute(styleContainer, "aui-id", key);
            this.renderer.appendChild(styleContainer, styleContent);
            this.renderer.appendChild(this.document.head, styleContainer);
            styleData = {
                id: id,
                key: key,
                styleContainer: styleContainer,
                styleContent: styleContent,
                value: {
                    fn: fn,
                    arg: arg
                }
            };
            this._styleMap.set(key, styleData);
            return styleData;
        }
        else {
            return this._styleMap.get(key);
        }
    };
    /** #style */
    /** #style */
    LyTheme.prototype.createClassContent = /** #style */
    function (value, id) {
        return "." + id + "{" + value + "}";
    };
    /** #style */
    /** #style */
    LyTheme.prototype.createStyleContent = /** #style */
    function (styleData) {
        return this.renderer.createText("." + styleData.id + "{" + (_a = styleData.value).fn.apply(_a, styleData.value.arg) + "}");
        var _a;
    };
    /** Update style of StyleData */
    /** Update style of StyleData */
    LyTheme.prototype.updateStyleValue = /** Update style of StyleData */
    function (style, styleText) {
        var styleContent = styleText;
        this.renderer.removeChild(style.styleContainer, style.styleContent);
        this.renderer.appendChild(style.styleContainer, styleContent);
        this._styleMap.set(style.key, Object.assign({}, style, {
            styleContainer: style.styleContainer,
            styleContent: styleContent
        }));
    };
    /** #style: Update all styles */
    /** #style: Update all styles */
    LyTheme.prototype.updateOthersStyles = /** #style: Update all styles */
    function () {
        var _this = this;
        this._styleMap.forEach(function (styleData) {
            var newStyleValue = _this.createStyleContent(styleData);
            _this.updateStyleValue(styleData, newStyleValue);
        });
    };
    /** Replace old class by newClass */
    /** Replace old class by newClass */
    LyTheme.prototype.updateClass = /** Replace old class by newClass */
    function (elementRef, renderer, newClass, oldClass) {
        if (oldClass) {
            renderer.removeClass(elementRef.nativeElement, oldClass);
        }
        renderer.addClass(elementRef.nativeElement, newClass);
    };
    LyTheme.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LyTheme.ctorParameters = function () { return [
        { type: AlyleServiceConfig, decorators: [{ type: Optional },] },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
        { type: DomSanitizer, },
        { type: RendererFactory2, },
    ]; };
    return LyTheme;
}());
export { LyTheme };
export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
export function mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(function (key) {
            if (isObject(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, (_a = {}, _a[key] = source[key], _a));
                }
                else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, (_b = {}, _b[key] = source[key], _b));
            }
            var _a, _b;
        });
    }
    return output;
}
export function parsePalette(palette) {
    var iterate = function (obj, keyObject) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var key$ = keyObject ? keyObject + "__" + key : key;
                if (obj[key] !== null &&
                    typeof obj[key] === 'string' &&
                    key !== 'default') {
                    obj[key] = { default: obj[key] };
                }
                if (typeof obj[key] === 'object') {
                    iterate(obj[key], key$);
                }
            }
        }
        return obj;
    };
    return iterate(Object.assign({}, palette));
}
function createKeyOf(str) {
    return str.split('').map(function (char) {
        return char.charCodeAt(0).toString(36);
    }).join('·');
}
//# sourceMappingURL=theme.service.js.map